export default __webpack_public_path__ + "static/media/login_background.f60f222f.jpg";